export class HTTPError extends Error {
    public readonly status: number;

    #name: string = "HTTPError";

    constructor(status: number, message: string, options?: ErrorOptions) {
        super(message, options);
        this.status = status;
    }

    get name(): string {
        return `${this.#name} ${this.status}`;
    }
}
